import { Box, Text } from '@redbubble/design-system';
import styles from './Topic.module.scss';

interface TopicProps {
  title: string;
  onClick?: (
    clickEvent: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  href?: string;
  element?: string;
}

export const Topic: React.FC<TopicProps> = ({
  title,
  onClick,
  href,
  element,
}) => {
  return (
    <Box
      className={styles.topic}
      onClick={onClick}
      data-testid="topic-box"
      role="link"
      element={element}
      href={href}
    >
      <Text type="display5">{title}</Text>
    </Box>
  );
};
